import { Page } from '$core/models/page';
import { EyeSightService } from '$core/services/eye-sight.service';
import { ResizeService } from '$core/services/resize.service';
import {
  AfterViewInit,
  Component,
  computed,
  inject,
  OnDestroy,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { StaticStorage } from '$core/services/static';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements AfterViewInit, OnDestroy {
  protected readonly router = inject(Router);

  private readonly staticStorage = inject(StaticStorage);
  private readonly resizeService = inject(ResizeService);
  private readonly eyeService = inject(EyeSightService);

  public readonly faChevronDown = faChevronDown;
  public readonly Page: Page;

  public thumb = {
    offset: 0,
    width: 0,
    opacity: 0,
  };

  public routerLinkActiveClass = 'current';
  public isDropdownToggledManually = false;
  public isHoverOnDropdow = false;

  protected readonly sections = computed(
    () => this.staticStorage.static().header.sections
  );

  constructor() {
    this.checkRouterEvents();
  }

  public ngAfterViewInit() {
    this.eyeService.status$.pipe(untilDestroyed(this)).subscribe((e) => {
      setTimeout(() => {
        this.updateLineDimension();
      }, 0);
    });

    if (this.resizeService.resizing$) {
      this.resizeService.resizing$.pipe(untilDestroyed(this)).subscribe((e) => {
        if (e) {
          this.updateLineDimension();
        }
      });
    }

    requestAnimationFrame(this.updateLineDimension.bind(this));
  }

  public onMouseLeave(dropdown: BsDropdownDirective) {
    setTimeout(() => {
      if (this.isHoverOnDropdow) {
        return;
      }

      dropdown.hide();
    }, 0);
  }

  private checkRouterEvents() {
    this.router.events.subscribe((event) => {
      requestAnimationFrame(() => {
        if (event instanceof NavigationEnd) {
          this.updateLineDimension();
        }
      });
    });
  }

  private updateLineDimension() {
    const container = document.getElementById('line-container');

    if (!container) {
      return;
    }

    const content =
      container.querySelector('.ng-scroll-viewport') ||
      container.querySelector('.ng-scroll-content') ||
      container.querySelector('.header-menu__inner');

    if (!content) {
      return;
    }

    const el: HTMLElement = container.querySelector(
      `.${this.routerLinkActiveClass}`
    );

    if (!el) {
      this.thumb.opacity = 0;
      return;
    }

    this.thumb.opacity = 1;
    this.thumb.offset = el.offsetLeft;
    this.thumb.width = el.offsetWidth;
  }

  public closeDropdown(dropdown: BsDropdownDirective) {
    dropdown['timeout'] = setTimeout(() => dropdown.hide(), 100);
  }

  public preventClosingDropdown(dropdown: BsDropdownDirective) {
    clearInterval(dropdown['timeout']);
  }

  public ngOnDestroy(): void {}
}
